import { render } from "./ProspectsOptions.vue?vue&type=template&id=f0f64972"
import script from "./ProspectsOptions.vue?vue&type=script&lang=js"
export * from "./ProspectsOptions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__